import React from 'react';
import {useLocation} from 'react-router-dom';
import {Navbar, Container, Nav} from 'react-bootstrap';
import {useSelector, useDispatch} from 'react-redux';

import routes from 'routes.js';
import 'assets/css/accueil.css';
import {setToken} from '../../actions/index';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';

/**
 * This function is called to display the header.
 * @function Header
 * @return {HTML} return the header.
 */
function Header() {
  const dispatch = useDispatch();
  const location = useLocation();

  const getBrandText = () => {
    let routeToReturn = '';
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        console.log('routes:  ', routes[i].name);
        if (routes[i].name == 'Accueil') {
          routeToReturn = t(translations.HOME_TITLE);
        } else if (routes[i].name == 'Liste de Rendez Vous') {
          routeToReturn = t(translations.APPOINTMENT_TITLE);
        } else if (routes[i].name == 'mes réunions') {
          routeToReturn = t(translations.MEETING_TITLE);
        } else if (routes[i].name == 'Conciergerie') {
          routeToReturn = t(translations.CONCIERGE_SERVICE_TITLE);
        } else if (routes[i].name == 'Colis') {
          routeToReturn = t(translations.PARCEL_TITLE);
        } else if (routes[i].name == 'Évènements') {
          routeToReturn = t(translations.EVENT_TITLE);
        } else if (routes[i].name == 'Salle de Sport') {
          routeToReturn = t(translations.GYM_TITLE);
        } else if (routes[i].name == 'Beauty Room') {
          routeToReturn = t(translations.BEAUTY_ROOM_TITLE);
        } else if (routes[i].name == 'Mon Profil') {
          routeToReturn = t(translations.PROFILE_TITLE);
        } else if (routes[i].name == 'Place de Parking') {
          routeToReturn = t(translations.PARKING_TITLE);
        }
        return routeToReturn;
      }
    }
    return 'Brand';
  };

  const {t, i18n} = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  const logout = () => {
    dispatch(setToken(''));
    window.location.reload();
  };

  const User = useSelector((state) => state.user);
  const isVipLanEnabled = User?.user?.vip?.lan === true;

  return (
    <Navbar expand="lg" id="navbar">
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          <a className="navbar-brand ceraPro" href="/resident/home">
            <img
              src={require('assets/img/HAGD-new-logo.png').default}
              alt=""
              width="50"
              height="50"
              className=""
            />{' '}
            {getBrandText()}
          </a>
        </div>

        <Nav.Link className="m-0 d-none d-sm-none d-md-block">
          <span className="no-icon ml-1 ceraPro">
            {' '}
            {t(translations.HELLO) +
              ' ' +
              User['user']['firstName'] +
              ' ' +
              t(translations.HOME_SUBTITLE)}
          </span>
        </Nav.Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="mr-2">
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav mr-auto" navbar></Nav>
          <Nav className="ml-auto " navbar>
            <Nav.Item className={'d-lg-none d-md-none d-sm-none'}>
              <Nav.Link className="m-0" href="/resident/home">
                <span className="no-icon ml-1 ceraPro">
                  {t(translations.HOME_TITLE)}
                </span>
              </Nav.Link>
            </Nav.Item>
            {isVipLanEnabled == true ? (
              <Navbar.Brand
                href="#pablo"
                style={{marginTop: '2%'}}
                onClick={(e) => e.preventDefault()}
              >
                <button
                  onClick={() => changeLanguage('fr')}
                  style={{background: 'none', border: 'none'}}
                >
                  <img
                    src={require('assets/france-flag-icon.png').default}
                    alt="Français"
                    style={{width: '30px', height: '20px'}}
                  />
                </button>
                <button
                  onClick={() => changeLanguage('en')}
                  style={{background: 'none', border: 'none'}}
                >
                  <img
                    src={require('assets/united-kingdom-flag-icon.png').default}
                    alt="English"
                    style={{width: '30px', height: '20px'}}
                  />
                </button>
              </Navbar.Brand>
            ) : null}
            <Nav.Item>
              <Nav.Link className="m-0" href="/resident/profile">
                <span className="no-icon ml-1 ceraPro">
                  {t(translations.PROFILE_SUBTITLE)}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#pablo"
                onClick={(e) => {
                  logout();
                }}
              >
                <span className="no-icon ml-1 ceraPro">
                  {t(translations.LOGOUT_TITLE)}
                </span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
